<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h11">Part One – Autumn</h1>
<p class="p11"><img alt="img5.png" height="173" src="images/img5.png" width="328"/></p>
<p class="p11"><span class="t16">P</span><span class="t17">ART</span><span class="t16"> O</span><span class="t17">NE</span></p>
<p class="p11"><span class="t16">A</span><span class="t17">UTUMN</span></p>
<p class="p3"> </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 007.vue?6f5df198